import Phaser from 'phaser'

export default class GameGuide extends Phaser.Scene {
    constructor() {
        super('guide');
    }

    init() {
        //get user data
        //get user progress
    }


    create() {
        var self = this;
        let tutorialBackground = this.add.sprite(400, 800, 'bg', 'BG-ingame');
        this.guidePanel = this.add.sprite(0, 0, 'ui', 'window-tutorial');
        this.okButton = this.add.sprite(0, 0, 'ui', 'button-ok');
        this.okButton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            self.okButton.setScale(1);
            self.scene.resume('mainmenu');
            self.scene.stop('guide');
        });
        self.okButton.on('pointerover', function() {
            self.okButton.setScale(1.2);
        });
        self.okButton.on('pointerout', function() {
            self.okButton.setScale(1);
        });



        //align Panels
        Phaser.Display.Align.In.Center(this.guidePanel, tutorialBackground);
        Phaser.Display.Align.In.Center(this.okButton, this.guidePanel, 0, 380);

    }
}